import { DraftingCompass, Wrench, LifeBuoy } from "lucide-react";

const PILLARS = [
  {
    step: "01",
    icon: DraftingCompass,
    title: "DESIGN",
    sub: "Architecting complete solutions",
    desc: "AutoCAD layouts, load calculations and client-need centric engineering — value for money by design.",
  },
  {
    step: "02",
    icon: Wrench,
    title: "INSTALL",
    sub: "Flawless workmanship",
    desc: "Certified engineers, structured cabling and clean racks — finished on schedule.",
  },
  {
    step: "03",
    icon: LifeBuoy,
    title: "SERVICE",
    sub: "Training & rapid troubleshooting",
    desc: "Handover training and after-sales response within 12 to 24 hours — for the life of your system.",
  },
];

export default function AboutManifesto() {
  return (
    <section id="about" className="relative scroll-mt-24 overflow-hidden px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24" data-testid="about-section">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <img
          data-parallax-img
          src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1800&auto=format&fit=crop"
          alt=""
          className="absolute -top-[12%] left-0 h-[124%] w-full object-cover opacity-[0.07]"
        />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(30,58,95,0.25),transparent_60%)]" />
      </div>
      <div className="relative mx-auto max-w-7xl">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
          <div data-reveal>
            <p className="kicker mb-4">About Us</p>
            <p className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1 font-heading text-base font-extrabold uppercase tracking-[0.25em] sm:text-lg" aria-hidden="true">
              <span className="text-stroke">Secure</span>
              <span className="text-brand">·</span>
              <span className="text-stroke">Connect</span>
              <span className="text-brand">·</span>
              <span className="text-stroke">Automate</span>
            </p>
            <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">
              A 24-year legacy of secure, connected spaces
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-slate-300 sm:text-base">
              A 24-year legacy since 2002. Pan-India presence with local support. Under the
              technical leadership of Business Head <span className="font-semibold text-white">Abhishek Agarwal</span> (B.Tech Electronics).
            </p>
            <blockquote className="mt-8 border-l-2 border-brand pl-5 font-heading text-lg sm:pl-6 sm:text-xl font-semibold leading-relaxed text-white sm:text-2xl">
              “We sell solutions wrapped with services, not products packed in boxes. We are not
              the cheapest, but we are worth our price.”
            </blockquote>
          </div>

          <div className="grid content-start gap-5 sm:gap-6 md:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3">
            {PILLARS.map((p, i) => (
              <article
                key={p.title}
                data-testid={`pillar-${p.title.toLowerCase()}`}
                data-reveal
                data-delay={i * 0.1}
                className="group relative overflow-hidden rounded-2xl border border-slate-700/70 bg-slate-900/60 p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/60"
              >
                <span className="pointer-events-none absolute -right-3 -top-6 select-none font-heading text-8xl font-extrabold text-white/[0.05]">
                  {p.step}
                </span>
                <span className="font-tech text-xs tracking-[0.3em] text-slate-500">{p.step}</span>
                <p.icon size={22} className="mt-4 text-brand" />
                <h3 className="mt-3 font-heading text-xl font-bold tracking-wide text-white">{p.title}</h3>
                <p className="mt-1 text-xs font-medium uppercase tracking-wider text-slate-400">{p.sub}</p>
                <p className="mt-3 text-xs leading-relaxed text-slate-400 sm:text-sm">{p.desc}</p>
              </article>
            ))}
          </div>
        </div>

        <div
          data-reveal
          data-testid="one-vendor-advantage"
          className="mt-12 flex flex-col items-start gap-5 rounded-2xl sm:mt-14 border border-brand/40 bg-gradient-to-r from-brand/15 via-brand/5 to-transparent p-7 md:flex-row md:items-center md:justify-between sm:p-9"
        >
          <div>
            <p className="kicker mb-2">One Vendor Advantage</p>
            <p className="max-w-2xl font-heading text-lg font-semibold leading-relaxed text-white sm:text-xl">
              Zero blame game. We save your time and energy by keeping all solutions under one roof.
            </p>
          </div>
          <span className="shrink-0 whitespace-nowrap rounded-full bg-brand px-6 py-3 font-tech text-xs uppercase tracking-[0.2em] text-white">
            15+ Solutions · 1 Roof
          </span>
        </div>
      </div>
    </section>
  );
}
